import { Col, Empty, theme } from "antd";
import { useEffect, useRef, useState } from "react";
import { Chart } from "@antv/g2";

// https://g2.antv.antgroup.com/en/examples

export interface VisualProps {
  readonly className?: string;
  readonly data?: any;
  readonly width?: string;
  readonly height?: string;
  readonly render: (chart: Chart, data: any) => void;
}

function Visual(props: VisualProps) {
  const ref = useRef<HTMLDivElement>(null!);
  const { token } = theme.useToken();
  const [chart, setChart] = useState<Chart>(null!);

  useEffect(() => {
    const chart = new Chart({
      container: ref.current,
      autoFit: true,
    });
    if (props.data && chart) {
      props.render(chart, props.data);
    }
    chart.render();
    setChart(chart as Chart);

    return () => {
      chart.destroy();
    };
  }, []);

  useEffect(() => {
    if (chart) {
      props.render(chart, props.data);
    }
    chart?.render();
  }, [props.data, chart]);

  return (
    <div
      className={`relative flex flex-col ${props.className}`}
      style={{
        backgroundColor: token.colorBgLayout,
        borderRadius: token.borderRadius,
        width: props.width ?? "100%",
        height: props.height ?? "256px",
      }}
    >
      <div ref={ref} className={`h-full w-full pt-4`}></div>
      {!Object.keys(props.data || {}).length && !Array.isArray(props.data) && (
        <div className="absolute bottom-0 left-0 right-0 top-0 flex flex-col items-center justify-center">
          <Empty description="" />
        </div>
      )}
    </div>
  );
}

export default Visual;
